<template>
  <base-section
    id="gallery"
    class="bg-gallery"
  >
    <v-tabs
      v-model="tab"
      centered
      class="mb-12"
    >
      <v-tab
        v-for="(t, i) in tabs"
        :key="i"
        :value="i"
        class="text-capitalize"
      >
        {{ t }}
      </v-tab>
    </v-tabs>

    <v-container>
      <v-row v-if="loading">
        <v-col
          cols="12"
          class="text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          />
          <p class="mt-4">
            {{ $t('common.loading') }}
          </p>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          v-for="product in filteredProducts"
          :key="product.title"
          class="gallery-card"
          cols="12"
          sm="6"
          md="4"
        >
          <v-fade-transition>
            <product-card
              v-bind="product"
              :src="product.path"
              :item-id="product.id"
              :clickable="product.clickable"
              height="300"
              width="100%"
            />
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import productsData from '@/data/products.json'
  import { loadImage } from '@/utils/imageLoader'
  import ProductCard from '@/components/ProductCard'

  export default {
    name: 'ProductsGallery',

    components: {
      ProductCard,
    },

    data: () => ({
      tab: 0,
      products: [],
      loading: true,
    }),

    computed: {
      tabs() {
        return [
          this.$t('products.gallery.enterprise_products'),
          this.$t('products.gallery.hardware'),
        ]
      },

      filteredProducts() {
        const filtered = this.products.filter(product => {
          // tab索引对应关系： 1=enterprise_products, 2=hardware
          // 根据tab索引获取对应的分类
          const categoryMap = {
            0: 'Drones',
            1: 'Hardware',
          }
          const targetCategory = categoryMap[this.tab]

          return product.category === targetCategory
        })
        console.log('Filtered products:', filtered.length, 'Tab:', this.tab, filtered)
        return filtered
      },
    },

    async mounted() {
      await this.loadProducts()
    },

    methods: {
      async loadProducts() {
        this.loading = true
        try {
          const products = []
          for (const product of productsData.products) {
            try {
              const path = await loadImage(product.imgUrl)
              products.push({
                id: product.id,
                title: this.$t(product.title),
                desc: product.desc,
                subtitle: this.$t(product.subtitle),
                path: path,
                category: product.category,
                clickable: product.clickable !== false,
              })
            } catch (imgError) {
              console.warn(`Failed to load image for product ${product.id}:`, imgError)
              // 即使图片加载失败，也添加产品数据
              products.push({
                id: product.id,
                title: this.$t(product.title),
                desc: product.desc,
                subtitle: this.$t(product.subtitle),
                path: '',
                category: product.category,
                clickable: product.clickable !== false,
              })
            }
          }
          this.products = products
          console.log('Loaded products:', this.products.length, this.products)
        } catch (error) {
          console.error('Failed to load products:', error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style lang="sass">
  .bg-gallery
    background: url('~@/assets/bg-w-1.png') no-repeat center center
  .gallery-card
    transform-origin: center center 0
    transition: .3s cubic-bezier(.25,.8,.50,1)
</style>
